import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import loadable from '@loadable/component'
import config from '../../../config'
import OrderStatus from '../../../pages/Store/OrderStatus'
import PaypalErrorMessage from './PaypalErrorMessage'
import CheckoutErrorMessage from './CheckoutErrorMessage'

import { FormattedMessage } from 'react-intl'
import UnchargedStatus from './UnchargedStatus'
import { connect } from 'react-redux'
import * as actionsCheckout from '../../../actions/checkout'
import * as actionsRequests from '../../../actions/requests'
import { bindActionCreators } from 'redux'
import CloseButton from './../../../components/shared/CloseButton/CloseButton'
import ReactGA from 'react-ga'
import { isMobile } from 'react-device-detect'
import { Modal, ModalClose, ModalBody, ModalFooter } from './CheckoutModalStyledComponents'

const Checkout = loadable(() => import('./Checkout'))

const CheckoutModal = ({ checkout, actionsRequests, actionsCheckout, ct, merchantId, toggle, isOpen, storeId }) => {
  const modalProps = {
    checkout,
    actionsRequests,
    actionsCheckout,
    ct,
    merchantId,
    toggle,
    isOpen,
    storeId
  }

  useEffect(() => {
    loadPayPalScript()

    return () => {
      if (checkout.paymentStatus === 'pending') {
        ReactGA.event({
          category: 'store',
          action: 'checkout_exit',
          label: storeId
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const loadPayPalScript = () => {
    if (ct) {
      actionsCheckout.setCuratorToken(ct)
    }

    actionsRequests.incrementRequestCount()
    const isPaypalScriptLoaded = typeof paypal !== 'undefined'

    if (!isPaypalScriptLoaded) {
      const script = document.createElement('script')
      script.setAttribute('async', 'true')
      script.onload = () => {
        actionsRequests.decrementRequestCount()
        actionsCheckout.setPaypalLoadedApi(true)
      }
      script.onerror = () => {
        if (process.env.NODE_ENV === 'development') {
          alert('Couldnt load paypalscript')
        }
      }
      const { scriptSrc, clientId } = config.paypal
      script.src = `${scriptSrc}?merchant-id=${merchantId}&client-id=${clientId}&disable-funding=credit&enable-funding=venmo&currency=USD`
      document.head.appendChild(script)
    } else {
      actionsRequests.decrementRequestCount()
      actionsCheckout.setPaypalLoadedApi(true)
    }
  }

  const isPending = checkout.paymentStatus === 'pending'
  const idFinished = checkout.paymentStatus === 'finished'
  const idUncharged = checkout.paymentStatus === 'uncharged'
  const isPaypalError = checkout.paymentStatus === 'paypalError'
  const isCheckoutError = checkout.paymentStatus === 'checkoutError'

  return (
    checkout.paypalApiLoaded && (
      <Modal isOpen={isOpen} toggle={toggle} size={isPaypalError ? 'sm' : 'lg'} backdrop>
        <ModalClose toggle={toggle} />
        <ModalBody noStyle={isPending || isPaypalError} className="pb-0">
          {isPaypalError && <PaypalErrorMessage toggleModal={toggle} checkoutError={checkout.paypalError} />}
          {isCheckoutError && <CheckoutErrorMessage toggleModal={toggle} checkoutErrors={checkout.checkoutErrors} />}
          {isPending && <Checkout {...modalProps} toggleModal={toggle} />}
          {idFinished && <OrderStatus {...modalProps} />}
          {idUncharged && <UnchargedStatus {...modalProps} />}
        </ModalBody>
        {!isPending && (!isPaypalError || !isCheckoutError) && (
          <ModalFooter>
            {!isMobile && (
              <CloseButton onClick={toggle}>
                <FormattedMessage id="general.modalClose" />
              </CloseButton>
            )}
          </ModalFooter>
        )}
      </Modal>
    )
  )
}

CheckoutModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  checkoutError: PropTypes.any,
  cart: PropTypes.object,
  checkout: PropTypes.object,
  storeId: PropTypes.string.isRequired,
  actionsRequests: PropTypes.object,
  actionsCheckout: PropTypes.object,
  ct: PropTypes.string,
  merchantId: PropTypes.string.isRequired
}

const mapStateToProps = state => ({
  checkout: state.checkout,
  cart: state.cart
})

const mapDispatchToProps = dispatch => ({
  actionsRequests: bindActionCreators(actionsRequests, dispatch),
  actionsCheckout: bindActionCreators(actionsCheckout, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutModal)
